import React from 'react'

export const SkinAssessmentFooterContext = React.createContext(null);